export default "__VITE_ASSET__ClB5UzgT__"